import { createAxiosClient } from "@/shared/axios/axios";
import type { AccountEntityExpandResponse } from "@/shared/generated/ExpHubApi";
import type { CustomerAdditionalInfoType } from "@/shared/@types/CustomerAdditionalInfoType";
import { handleAxiosError } from "@/shared/helper/handleAxiosError.helper";
import { createMockable } from "@/shared/helper/createMockable.helper";
import { getSelectedCustomer } from "@/shared/fixtures/mulesoft/shared/account/getSelectedCustomer";

interface GetCustomerParams {
  userId: string;
  customerId: string;
  infoTypes?: CustomerAdditionalInfoType[];
}

const getCustomerMock = async ({
  customerId,
}: GetCustomerParams): Promise<AccountEntityExpandResponse> => {
  await new Promise((r) => setTimeout(r, 250));
  return getSelectedCustomer({ customerId });
};

const getCustomerReal = async ({
  userId,
  customerId,
  infoTypes,
}: GetCustomerParams): Promise<AccountEntityExpandResponse> => {
  try {
    const client = await createAxiosClient();
    const expandParam =
      infoTypes && infoTypes.length > 0 ? `?expand=${infoTypes.join(",")}` : "";

    const response = await client.get(
      `/users/${userId}/accounts/${customerId}${expandParam}`,
    );
    return response.data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export const getCustomer = createMockable({
  name: "getCustomer",
  real: getCustomerReal,
  mock: getCustomerMock,
});
